import { defineStore } from 'pinia'
import { ref } from 'vue';

export const useExportStore = defineStore('export', {
  state: () => ({
    target: "origin",
    format: "dcm",
    export: false
  }),
  actions: {
    setExportOption(target: string, format: string) {
      this.target = target;
      this.format = format;
    },
    setExportState(state: boolean) {
      this.export = state;
    }
  },
  getters: {
    getTargetState(state): string {
      return state.target;
    },
    getFormatState(state): string {
      return state.format;
    },
    getExportState(state): boolean {
      return state.export;
    }
  },
});